import { FormElement, FormId } from "../../../../../components/enums";
import {
  ComplexFormSchemaComponents,
  FormSchema,
  SimpleFormSchemaComponents,
} from "../../../../../components/types";
import { Url } from "../../../../../router/enums";
import { selectDamagesImagesDescriptionFormData } from "../damages.selectors";

import { ComponentId } from "./enums";

export const form: FormSchema<
  SimpleFormSchemaComponents | ComplexFormSchemaComponents
> = {
  formId: FormId.DAMAGES_IMAGES_DESCRIPTION,
  selector: selectDamagesImagesDescriptionFormData,
  redirect: Url.OC_PROPERTY_SUMMARY,
  content: [
    {
      sections: [
        {
          id: "images-description-data-1",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.TEXTAREA,
              id: ComponentId.DESCRIPTION,
              label: "Opis uszkodzeń",
              required: true,
              limit: 1000,
              placeholder: "Opisz uszkodzenia swojego mienia",
            },
          ],
        },
        {
          id: "images-description-data-2",
          title: "Dodaj maksymalnie 10 szczegółowych zdjęć uszkodzeń mienia.",
          wrapper: { xs: 12 },
          components: [
            {
              type: FormElement.IMAGE_UPLOADER_MULTIPLE,
              id: ComponentId.ADDITIONAL_IMAGES,
              maxImageNumber: 10,
              imageSectionId: ComponentId.ADDITIONAL_IMAGES,
            },
          ],
        },
      ],
    },
  ],
};
